import { Injectable } from '@angular/core';

export interface MenuTab {
  active?: boolean;
  roles?: string[];
  name: string;
  title: string;
  route: string;
  subtabs?: MenuItem[];
}

export interface MenuItem {
  active?: boolean;
  title: string;
  route: string;
  name?: string;
}


@Injectable()
export class MenuBlock {
  public tabs: MenuTab[] = [
    {
      name: 'projects',
      title: 'menu.project.title',
      roles: ['user', 'admin', 'manager'],
      route: 'projects',
    },
    {
      name: 'tokens',
      title: 'menu.settings.title',
      roles: ['user', 'admin', 'manager'],
      route: 'account/tokens',
    }
  ];
  public tabSelected = <MenuTab>{};
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/menu-service-block.model.ts